// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_Yw-","cls2":"DebugPage-cls2_8_V DebugPage-cls1_Yw-"};